import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    const urlArr = url.includes('?') ? url.split('?') : url.split('#');
    let newUrl = '';
    urlArr.map( (value, index) => {
      if (index === 0) {
        newUrl = newUrl + value.toLocaleLowerCase();
      } else {
        newUrl = newUrl + '?' + value;
      }
    });
    return super.parse(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/LowerCaseUrlSerializer.ts